export const CATALOGUES_ROOT = 'catalogues-root';
export const CATALOGUES_IMAGE = 'catalogue-image-root';
export const currentCatalogue = '(max-width: 1023px) 250px, 310px';
export const nextCatalogue = '131px';
